<template>
    <v-container fluid class="mb-4">
        <v-toolbar text dark color="secondary">
            <v-toolbar-title>Lista de alunos</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                    <v-btn text v-on="on" v-if="isAdmin">
                        <v-icon left>add</v-icon>
                        Adicionar aluno
                    </v-btn>
                </template>
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs3>
                                    <v-text-field v-model="editedItem.numero" label="N.º" :rules="[inputRules.required]"></v-text-field>
                                </v-flex>
                                <v-flex xs9>
                                    <v-text-field v-model="editedItem.aluno.nome" label="Nome" :rules="[inputRules.required]"></v-text-field>
                                </v-flex>
                                <v-flex xs6>
                                    <v-select v-model="editedItem.aluno.sexo" label="Sexo" :items="sexos" :rules="[inputRules.required]"></v-select>
                                </v-flex>
                                <v-flex xs6>
									<v-menu v-model="datePickerMenu"
										:close-on-content-click="false" :nudge-right="40" 
										transition="scale-transition"
										offset-y min-width="290px">
										<template v-slot:activator="{ on }">
											<v-text-field v-model="editedItem.aluno.data_nascimento" label="Data de nascimento" prepend-icon="event" readonly v-on="on"></v-text-field>
										</template>
										<v-date-picker v-model="editedItem.aluno.data_nascimento" @input="datePickerMenu = false" no-title scrollable></v-date-picker>
									</v-menu>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" text @click="resetEditedData">Cancelar</v-btn>
                        <v-btn color="secondary" text @click="save">Gravar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

			<!-- TODO: usar componente para ConfirmDialog -->
			<!-- <ConfirmDialog :message="'Tem a certeza de que pretende apagar os dados deste aluno?'" :model="showConfirm"></ConfirmDialog> -->
			<v-dialog v-model="showConfirm" persistent max-width="400">
				<v-card>
					<v-card-title class="headline">Atenção</v-card-title>
					<v-card-text>Tem a certeza de que pretende apagar os dados deste aluno?</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="secondary" text @click="showConfirm = false">Cancelar</v-btn>
						<v-btn color="secondary" text @click="deleteConfirmed(editedItem); showConfirm = false;">Confirmar</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
        </v-toolbar>

		<v-container v-if="!isLoading && alunos.length === 0">
			<p class="text-center py-8">Sem alunos registados.</p>
		</v-container>

		<v-list two-line v-if="alunos.length > 0">
			<template v-for="(item, index) in alunos">
				<div :key="item.id">
					<v-list-item @click="goToAlunoInformacoes(item.aluno.id)">
						<v-list-item-content>
							<v-list-item-title>N.º {{ item.numero }} - {{ item.aluno.nome }} </v-list-item-title>
							<v-list-item-subtitle>Sexo: <strong>{{ item.aluno.sexo  == 'M' ? 'Masculino' : 'Feminino' }}</strong>, Data de nascimento: <strong>{{ item.aluno.data_nascimento }}</strong></v-list-item-subtitle>
						</v-list-item-content>

						<v-list-item-action>
							<div>
								<v-layout justify-center fill-height>
									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<v-btn icon ripple class="mx-2" v-on="on" @click="editItem(item)" @click.stop="">
												<v-icon color="secondary">edit</v-icon>
											</v-btn>
										</template>
										<span>Editar</span>
									</v-tooltip>
									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<v-btn icon ripple class="mx-2" v-on="on" v-if="isAdmin" @click="deleteItem(item)" @click.stop="">
												<v-icon color="secondary">delete</v-icon>
											</v-btn>
										</template>
										<span>Eliminar</span>
									</v-tooltip>

									<v-divider vertical></v-divider>

									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<v-btn icon ripple class="mx-2" v-on="on" @click="goToAlunoInformacoes(item.aluno.id)" @click.stop="">
												<v-icon color="secondary">description</v-icon>
											</v-btn>
										</template>
										<span>Informações</span>
									</v-tooltip>
									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<v-btn icon ripple class="mx-2" v-on="on" @click="goToAlunoNotas(item.id)" @click.stop="">
												<v-icon color="secondary">school</v-icon>
											</v-btn>
										</template>
										<span>Resultados escolares</span>
									</v-tooltip>
								</v-layout>
							</div>
						</v-list-item-action>
					</v-list-item>

					<v-divider :key="index" v-if="index < alunos.length-1"></v-divider>
				</div>
			</template>
		</v-list>

		<v-divider></v-divider>
        <v-btn color="primary" text class="my-4" @click="goBack()">
            <v-icon left>arrow_back</v-icon>
            Voltar
        </v-btn>

		<Loading :isLoading="isLoading" />

		<error-dialog :show-dialog="this.errorMessage.show" :error-message="this.errorMessage"></error-dialog>
    </v-container>
</template>

<script>
    import Vue from 'vue'
	import StaticData from '../data/static-data.js';
	Vue.use(StaticData);

	import UserService from '@/services/user.service';
	const userService = new UserService();

	import Loading from "@/components/Loading";

    export default {
		components: {
			Loading
		},

        data: () => ({
			dialog: false,
			errorMessage: {
				show: false
			},
			showConfirm: false,
			isLoading: false,
			datePickerMenu: false,
			sexos: StaticData.Sexos,
            alunos: [],
            editedIndex: -1,
            editedItem: {
				// turma: this.$route.params.turmaId,
				numero: null,
				aluno: {
					nome: null,
					sexo: null,
					data_nascimento: null
				}
            },
            defaultItem: {
				// turma: this.$route.params.turmaId,
				numero: null,
				aluno: {
					nome: null,
					sexo: null,
					data_nascimento: null
				}
            },
            inputRules: {
                required: value => !!value || 'Campo obrigatório'
            }
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Adicionar aluno' : 'Editar aluno'
            },
			isAdmin () {
				return userService.isAdmin();
			}
        },

        watch: {
            dialog (val) {
                val || this.resetEditedData()
            }
        },

        created () {
			this.turmaId = this.$route.params.turmaId;
			this.loadAlunos();
        },

        methods: {
			loadAlunos () {
				this.isLoading = true;

				this.$http.get(process.env.VUE_APP_API_ROOT + `/lista-alunos?turma_id=${this.turmaId}`).then(function(data){
                    return data.json();
                }).then(function(data){
                    // console.log(data);
                    this.alunos = data;

					this.isLoading = false;
                }, response => { // error callback
					this.isLoading = false;
				});
			},
            editItem (item) {
                this.editedIndex = this.alunos.indexOf(item)
                this.editedItem = Object.assign({}, item)
				this.dialog = true
				console.log(this.editedIndex)
            },
            deleteItem (item) {
                this.editedIndex = this.alunos.indexOf(item)
                this.editedItem = Object.assign({}, item)
				this.showConfirm = true;
            },
            resetEditedData () {
                this.dialog = false;
				this.editedItem = Object.assign({}, this.defaultItem);
				this.editedIndex = -1;
            },
            save () {
				this.isLoading = true;

				console.log("this.editedItem", this.editedItem);

                if (this.editedIndex > -1) {
					this.$http.put(process.env.VUE_APP_API_ROOT + `/aluno-turma/${this.editedItem.id}/`, this.editedItem).then(function(data){
						console.log(data);
						this.submitted = true;

						Object.assign(this.alunos[this.editedIndex], data.body);

						this.resetEditedData();

						this.isLoading = false;
					}, response => { // error callback
						console.log(response);

						this.errorMessage.message = "Ocorreu um erro ao editar os dados do aluno.";
						this.errorMessage.show = true;

						this.isLoading = false;
					});
				}
				else {
					this.editedItem.turma = this.$route.params.turmaId;

					this.$http.post(process.env.VUE_APP_API_ROOT + '/aluno-turma/', this.editedItem).then(function(data){
						console.log(data);
						this.submitted = true;
						
						this.alunos.push(data.body)

						this.resetEditedData();

						this.isLoading = false;
					}, response => { // error callback
						console.log(response);

						this.errorMessage.message = "Ocorreu um erro ao gravar os dados do novo aluno.";
						this.errorMessage.show = true;

						this.isLoading = false;
					});
                }
			},
			deleteConfirmed (item) {
				this.isLoading = true;

				this.$http.delete(process.env.VUE_APP_API_ROOT + `/aluno-turma/${item.id}/`).then(function(data){
					console.log(data);
					this.submitted = true;

					const index = this.alunos.indexOf(item);
					this.alunos.splice(index, 1);

					this.isLoading = false;
				}, response => { // error callback
					console.log(response);

					this.errorMessage.message = "Ocorreu um erro ao eliminar os dados do aluno.";
					this.errorMessage.show = true;

					this.isLoading = false;
				});
			},
            goToAlunoInformacoes (aluno_id) {
				// console.log(aluno_id)
                this.$router.push({ name: 'aluno-informacoes', params: { alunoId: aluno_id }})
            },
            goToAlunoNotas (aluno_turma_id) {
				// console.log(aluno_id)
                this.$router.push({ name: 'aluno-notas', params: { alunoTurmaId: aluno_turma_id }})
            },
			goBack () {
                window.history.length > 1
                    ? this.$router.go(-1)
                    : this.$router.push('/')
            }
        }
    }
</script>